var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTastTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    stroke: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53033 10.9697C6.23744 10.6768 5.76256 10.6768 5.46967 10.9697C5.17678 11.2626 5.17678 11.7374 5.46967 12.0303L6.53033 10.9697ZM15.0303 8.53033C15.3232 8.23744 15.3232 7.76256 15.0303 7.46967C14.7374 7.17678 14.2626 7.17678 13.9697 7.46967L15.0303 8.53033ZM8.35858 13.8586L7.82825 14.3889L8.35858 13.8586ZM8.64142 13.8586L9.17175 14.3889L8.64142 13.8586ZM5.46967 12.0303L7.82825 14.3889L8.88891 13.3282L6.53033 10.9697L5.46967 12.0303ZM9.17175 14.3889L15.0303 8.53033L13.9697 7.46967L8.11109 13.3282L9.17175 14.3889ZM7.82825 14.3889C8.19925 14.7599 8.80075 14.7599 9.17175 14.3889L8.11109 13.3282C8.32588 13.1135 8.67412 13.1135 8.88891 13.3282L7.82825 14.3889Z",
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTastTick);
export default __webpack_public_path__ + "static/media/tast-tick.3ccb75a7.svg";
export { ForwardRef as ReactComponent };